import styles from "../../styles/common/Logo.module.scss"

import {Link} from "react-router-dom";
import clsx from "clsx";

import {ReactComponent as LogoFull} from "../../assets/images/logo-new-full.svg";
import {ReactComponent as LogoBrandmark} from "../../assets/images/logo-new-brandmark.svg";

interface LogoProps{
  displayBrandmark?: boolean;
}

function Logo({displayBrandmark}:LogoProps) {
  return (
    <Link to='/' className={clsx(styles.cLogo, "c-logo", displayBrandmark && 'is-brandmark')}>
      {displayBrandmark? (<LogoBrandmark/>):(<LogoFull/>)}
    </Link>
  );
}

export default Logo;